import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { AppService, CoreProxyService, CoreTypes, SharedCommonService, StringDateTimePipe } from 'common-cloudstudio';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export class CameraSnapshots extends CoreTypes.CameraSnapshotReference {
  Checked: boolean;
  DateString: string;
}


@Component({
  selector: 'app-modal-snapshots',
  templateUrl: './modal-snapshots.component.html',
  styleUrls: ['./modal-snapshots.component.scss']
})
export class ModalSnapshotsComponent implements OnInit {
  @ViewChild("confirmRemove") private _confirmRemove: any;
  @ViewChild('modalSnapshots', {static: true}) private _modal: any;

  cameraSnapshots: CoreTypes.CameraSnapshot = new CoreTypes.CameraSnapshot();
  snapshotsID: number = 0;
  endpointID: number = 0;
  status: number = 0;
  loadSnapshots: number = 0;
  imageUrl: string = "";
  showManageSnapshots: boolean = false;
  dashboardID: number = 0;
  selectedSnapshots: CameraSnapshots[] = [];
  cameraSnapshotsList: CameraSnapshots[] = [];
  _selectAllSnapshots: boolean = false;
  _unCheckAllSnapshots: boolean = false;
  errorMessage: string;
  errorBackend: string;
  maxSnapshotID: number | null = null;
  minSnapshotID: number | null = null;

  constructor(
    private router: Router,
    public _route: ActivatedRoute,
    public _appService: AppService,
    public _coreProxyService: CoreProxyService,
    private _toasterService: ToasterService,
    private datetimePipe: StringDateTimePipe,
    public _sharedCommonService: SharedCommonService,
    private http: HttpClient
  ) {
    this._route.params.subscribe((event) => {
      if (+event["endpointId"] && +event["snapshotsId"]) {
        this.endpointID = +event["endpointId"];
        this.snapshotsID = +event["snapshotsId"];
      }
      if(+event["dashboardId"]){
        this.dashboardID = +event["dashboardId"];
        this.getCameraSnapshotByDashboard();
      }
      this.initData();
    });
  }

  ngOnInit(): void {
    if(this.router.url.indexOf('manage-snapshots') > -1) {
      this.showManageSnapshots =  true;
    }
    this._sharedCommonService.onRefreshWidgetsSnapshots.next(null);
    setTimeout(() => { this._modal.open(); }, 50);
  }

  initData() {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state?.snapshot;
    if (state) {
      this.maxSnapshotID = state?.max;
      this.minSnapshotID = state?.min;
      console.log(this.maxSnapshotID, this.minSnapshotID)
    }
    this.status = 0;
    if(this.snapshotsID && this.snapshotsID != 0) {
      this._coreProxyService.DeviceService.GetCameraSnapshot(
        this.snapshotsID,
        data => {
          this.status = 1;
          this.cameraSnapshots = data;
          this.imageUrl = this.cameraSnapshots.FileAsset.Url;
        },
        err => {
          this.status = 2;
          this._appService.showException(err);
        }
      )
    } else {
      this.status = 1;
      this.cameraSnapshots.FileAsset = {
        FileAssetID: 0,
        ContentBase64: null,
        IsPublic: false,
        Url: null,
      }
    }
  }

  goNext(event, nextID) {
    event.preventDefault();
    this.snapshotsID = nextID;
		this.initData();
	}

	goPrevious(event, prevID) {
    event.preventDefault();
    this.snapshotsID = prevID;
		this.initData();
	}

  getCameraSnapshotByDashboard() {
    this.loadSnapshots = 0;
    this.cameraSnapshotsList = [];
    this._coreProxyService.DashboardService.GetCameraSnapshotByDashboardId(
      this._appService.getAccessToken(),
      this._appService.getFacilityID(),
      this.dashboardID,
      res => {
        this.loadSnapshots = 1;
        let dateFormat = this._appService.regionalFormats.value?.Frontend?.DateTimeFormatWithSeconds;
        res.forEach(item => {
          this.cameraSnapshotsList.push({
            CameraSnapshotID: item.CameraSnapshotID,
            FileAsset: item.FileAsset,
            Token: item.Token,
            Checked: false,
            DateString: moment(this.datetimePipe.transform(item.DateTime)).format(dateFormat),
            DateTime: item.DateTime,
            DeviceDescription: item.DeviceDescription,
            EndpointDescription: item.EndpointDescription,
            WidgetDescription: item.WidgetDescription,
            NextCameraSnapshotID: item.NextCameraSnapshotID,
            PreviousCameraSnapshotID: item.PreviousCameraSnapshotID
          });
        })
      },
      err =>{
        this.loadSnapshots = 2;
        this._appService.showException(err);
      }
    )
  }

  close() {
    this.cameraSnapshots.CameraSnapshotID = 0;
    this._sharedCommonService.onRefreshWidgetsSnapshots.next(null);
    setTimeout(() => this.router.navigate([{outlets: { modal: null}}]), 200);
  }

  selectSnapshot(snapshot) {
    this.errorBackend = ""
    if(snapshot.Checked) {
      this.selectedSnapshots.push(snapshot);
      if(this._unCheckAllSnapshots) this._unCheckAllSnapshots = false;
    } else {
      let index = this.selectedSnapshots.findIndex(x=> x.FileAsset.FileAssetID === snapshot.FileAsset.FileAssetID);
      if(index > -1) {
        this.selectedSnapshots.splice(index, 1);
      }
    }
    this._selectAllSnapshots = (this.selectedSnapshots.length > 0 && this.selectedSnapshots.length === this.cameraSnapshotsList.length)
  }

  checkAll() {
    this.selectedSnapshots = [];
    this._unCheckAllSnapshots = false;
    this.cameraSnapshotsList.forEach(item => {
      item.Checked = this._selectAllSnapshots;

      if (this._selectAllSnapshots)
        this.selectedSnapshots.push(item);
    });
  }

  unCheckAll() {
    this.selectedSnapshots = [];
    this._selectAllSnapshots = false;
    this.cameraSnapshotsList.forEach(item => {
      item.Checked = false;
    });
  }

  downloadSnapshots() {
    this.loadSnapshots = 0;
    this.errorBackend = "";
    let fileNumber = Math.floor(1000 + Math.random() * 9000);
    let fileName;
    let cloneCameraSnapshots = JSON.parse(JSON.stringify(this.selectedSnapshots))
    cloneCameraSnapshots.map(x => {
      delete x.Checked
      delete x.DateString
      return x
    });

    if (this.selectedSnapshots.length === 1) {
      var dataURL = this.selectedSnapshots[0].FileAsset.Url;
      fileName = `Snapshot-${fileNumber}.png ${new Date().toLocaleString()}.png`;
    }
    this._coreProxyService.DashboardService.DownloadCameraSnapshotByIds(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      cloneCameraSnapshots,
      res => {
        if(this.selectedSnapshots.length > 1) {
          fileName = `Camera-Snapshots-${fileNumber}.zip ${new Date().toLocaleString()}.zip`;
        }
        if(res) {
          this.downloadFiles(res, fileName);
        } else {
          setTimeout(() => {
            this.loadSnapshots = 1;
            this.errorBackend = "Download could not be completed";
          }, 1000);
        }
      },
      err => {
        this.errorBackend = err.Message;
      }
    )
  }

  async downloadFiles(url: string, fileName:string) {

    this.downloadFile(url).subscribe(blob =>{
      const a = document.createElement('a')
      const objectUrl = URL.createObjectURL(blob)
      a.href = objectUrl;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(objectUrl);
      setTimeout(() => this.close(), 300);
      this._toasterService.pop('success', null, this._appService.CoreCommonLiterals.DownloadedSuccessfully);
    }, error => {
      this.errorBackend = "Download could not be completed";
      setTimeout(() => this.loadSnapshots = 1, 500);
    })
  }

  downloadFile(filename): Observable<Blob> {
    return this.http.get(filename, { responseType: 'blob' });
  }

  confirmOnRemove() {
    this._confirmRemove.open();
  }

  deleteSnapshots() {
    this.loadSnapshots = 0;
    this._coreProxyService.DashboardService.DeleteCameraSnapshotByIds(
      this._appService.getAccessToken(),
      this._appService.getClientID(),
      this.selectedSnapshots,
      () => {
        setTimeout(() => this.getCameraSnapshotByDashboard(), 100);
        this._confirmRemove.close();
        this._sharedCommonService.onRefreshWidgetsSnapshots.next(true);
        this._toasterService.pop('success', null, 'The images were deleted successfully');
        setTimeout(() => {
          this.loadSnapshots = 1;
          this.close()
        }, 800);
      },
      err =>{
        this._confirmRemove.close();
        this.errorMessage = err.Message;
        this.loadSnapshots = 2;
        this._appService.showException(err);
      }
    )
  }
}
